








import Vue, { PropType } from 'vue'
import { Spell } from '@/types'
import SpellListItem from '@/components/SpellListItem.vue'
import spellFilter, { SpellFilter } from '@/util/spell-filter'

export default Vue.extend({
  name: 'SpellList',
  data () {
    return {
      selectedSpells: [],
    }
  },
  props: {
    filter: {
      type: Object as PropType<SpellFilter>,
      required: true,
    },
  },
  computed: {
    spells (): Array<Spell> {
      return Object.values(this.$store.state.spells)
    },
    filterdSpells (): Array<Spell> {
      let filterdSpells = Object.values(this.spells)
      if (this.filter.search !== '') {
        filterdSpells = spellFilter.searchFilter(this.spells, this.filter.search)
      }

      if (this.filter.school !== 'All') {
        filterdSpells = spellFilter.schoolFilter(filterdSpells, this.filter.school)
      }

      if (this.filter.class !== 'All') {
        filterdSpells = spellFilter.classFilter(filterdSpells, this.filter.class)
      }

      if (this.filter.level !== -1) {
        filterdSpells = spellFilter.levelFilter(filterdSpells, this.filter.level)
      }

      return filterdSpells
    },
  },
  methods: {
    addSpells () {
      this.selectedSpells.forEach((spell) => {
        this.$store.commit('addToSpellBook', spell)
      })
      this.selectedSpells = []
    },
  },
  components: {
    SpellListItem,
  },
})
